const DropWrapper = ({
  children,
  onDropItem,
  onDragOver,
  style
}) => {

  const handleDragOver = (e) => {
    e.preventDefault();
    onDragOver && onDragOver(e);
  };

  const handleDrop = (e) => {
    e.preventDefault();

    const raw = e.dataTransfer.getData('application/json');
    if (!raw) return;

    const data = JSON.parse(raw);
    onDropItem && onDropItem(data);
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      style={style}
    >
      {children}
    </div>
  );
};

export default DropWrapper